// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"dd31006766--checkbox--V8SSh","label":"dd31006766--label--spcLW","box":"dd31006766--box--SMS_5","hasLabel":"dd31006766--hasLabel--TalIs"};